import { cloneDeep } from 'lodash';
import { ChartData } from '@app/_shared/providers/charting/chart.interface';
import * as echarts from 'echarts';
import * as moment from 'moment';
import { DEFAULT_PRECISION, Utils } from '@app/_helpers';

const chartOptionsTemplate = {
    tooltip: {
        trigger: 'axis',
        position: 'inside'
    },
    grid: {
        show: true,
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [],
        show: true
    },
    yAxis: {
        type: 'value',
        boundaryGap: [0, '100%'],
        show: true,
        min: (value) => {
            try {
                return value.min.toFixed(DEFAULT_PRECISION);
            } catch (error) {
                return value.min;
            }
        },
        max: (value) => {
            try {
                return value.max.toFixed(DEFAULT_PRECISION);
            } catch (error) {
                return value.max;
            }
        },
        axisPointer: {
            label: {
                precision: DEFAULT_PRECISION
            }
        }
    },
    series: [
        {
            name: 'Chart',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'average',
            itemStyle: {
                color: 'rgb(135, 206, 235)'
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgb(135, 206, 235)'
                }, {
                    offset: 1,
                    color: 'rgb(255, 255, 255)'
                }])
            },
            data: []
        }
    ]
};
export function getChartTOptions(chartData: ChartData[]) {
    const options = cloneDeep(chartOptionsTemplate);
    options.series[0].data = chartData.map(c => c.data);
    options.xAxis.data = chartData.map(c => moment(c.time).format('DD-MM-YYYY'));
    return options;
}
